import BaseComponent from '../../BaseComponent';
import { ClassNames } from '../../../utils/dom/css-classes';
import SelectorEngine from '../../../utils/dom/selector-engine';

const NAME = 'TopBackButton';

export default class TopBackButton extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	constructor(element, config) {
		super(element);
		if (this._element) {
			this.classPrefix = config.classPrefix;
			this.buttonClasses = config.buttonClasses || '';
			this.buttonLabel = config.buttonLabel || 'Back';
		}
	}

	markup() {
		return `
			<div class="u-flex u-align-center" style="flex-direction:row">
				<button class="${this.classPrefix}__form-back-button lta-navigational-btn ${this.buttonClasses}" aria-label="Go back">
					<svg class="lta-icon js-lta-text-input--btn-icon" height="12px" fill="currentColor" alt="caret-left-fill" aria-hidden="true" style="height: 12px; width: 12px;">
						<use xlink:href="/static/images/icons/lta-icons.svg#chevron-left-tf"></use>
					</svg>
					<span class="lta-navigational-btn__text u-fw-bold u-body2">
						${this.buttonLabel}
					</span>
				</button>		  		
		  	</div>
		`;
	}

	show() {
		const topBackButton = SelectorEngine.findOne(`.${this.classPrefix}__form-back-button`, this._element);
		topBackButton?.classList?.remove(ClassNames.Hidden);
	}

	hide() {
		const topBackButton = SelectorEngine.findOne(`.${this.classPrefix}__form-back-button`, this._element);
		topBackButton?.classList?.add(ClassNames.Hidden);
	}
}
